export default "__VITE_ASSET__DQqZVK4x__"